// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rootContainer {
  display: flex;
}

.rootContainer > * {
  background-color: black;
  /* Black*/
  font-size: 12px;
}

.aside-2 {
  background-color: black !important;
  /* Black*/
}

.wrapper {
  width: 100%;
  flex-flow: column wrap;
  align-items: stretch;
  text-align: center;
  background-color: black;
  /* Black*/
  border-radius: 25px 0px 0px 0px;
}

.wrapper > * {
  flex: 1 1 100%;
  padding: 10px;
  background-color: white;
  margin: 10px;
  text-align: center;
  font-size: 12px;
}

.header {
  display: flex;
}

.header > * {
  flex: 1 1 70%;
  background-color: white;
  color: white;
  text-align: right;
  font-size: 12px;
}

.footer {
  text-align: center;
  background: white;
}

.main {
  text-align: left;
  background-color: white;
}

/* Style page content - use this if you want to push the page content to the right when you open the side navigation */
#main {
  transition: margin-left 0.5s;
  padding: 20px;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}
@media all and (min-width: 600px) {
  .aside {
    flex: 1 0;
  }
  .sidenav.nav-expanded ~ .wrapper {
    margin-left: 240px;
    width: calc(100% - 240px);
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
    transition: margin-left 0.3s ease, width 0.3s ease;
  }
  .sidenav.nav-collapsed ~ .wrapper {
    margin-left: 70px;
    width: calc(100% - 70px);
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
    transition: margin-left 0.3s ease, width 0.3s ease;
  }
}
@media all and (max-width: 599px) {
  .rootContainer {
    flex-flow: column;
  }
  body {
    padding-left: 1em !important;
    padding-right: 0em !important;
    padding-top: 0em !important;
    margin-top: 0px;
  }
  .sidenav.nav-collapsed ~ .wrapper {
    margin-left: 0 !important;
    width: 100% !important;
    padding-top: 56px !important;
    border-radius: 0px !important;
    transition: padding-top 0.25s ease-in-out;
  }
  .sidenav.nav-expanded ~ .wrapper {
    margin-left: 0 !important;
    width: 100% !important;
    padding-top: 480px !important;
    border-radius: 0px !important;
    transition: padding-top 0.25s ease-in-out;
  }
  .wrapper {
    padding: 0px;
  }
  .wrapper > * {
    padding: 0px;
  }
  header {
    order: 1;
    flex: 3 1;
  }
  aside-2 {
    order: 2;
  }
  main {
    order: 3;
  }
  footer {
    order: 5;
  }
  .sidenav {
    padding-top: 0px !important;
  }
  .openSpan {
    position: relative !important;
    margin-top: -2px !important;
  }
}
body {
  padding: 2em;
}

label {
  margin-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

input {
  margin-right: 10px;
  padding-top: 10px;
}

.labelText {
  display: flex;
  flex-flow: row nowrap;
}

.labelText > * {
  flex: 1 1 100%;
  text-align: left;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAGA;EAOI,uBAAA;EACA,SAAA;EACA,eAAA;AANJ;;AAUA;EAEI,kCAAA;EACA,SAAA;AARJ;;AAWA;EAEI,WAAA;EACA,sBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,+BAAA;AAVJ;;AAaA;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EAEA,YAAA;EACA,kBAAA;EAEA,eAAA;AAZJ;;AAeA;EACI,aAAA;AAZJ;;AAgBA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EAEA,eAAA;AAdJ;;AAiBA;EAEI,kBAAA;EAEA,iBAAA;AAhBJ;;AAqBA;EAEI,gBAAA;EAGA,uBAAA;AArBJ;;AAwBA,sHAAA;AACA;EACI,4BAAA;EACA,aAAA;AArBJ;;AAwBA,gIAAA;AACA;EACI;IACI,iBAAA;EArBN;EAwBE;IACI,eAAA;EAtBN;AACF;AAyBA;EACI;IACI,SAAA;EAvBN;EA4BE;IACI,kBAAA;IACA,yBAAA;IACA,aAAA;IACA,iBAAA;IACA,gBAAA;IACA,sBAAA;IACA,kDAAA;EA1BN;EA6BE;IACI,iBAAA;IACA,wBAAA;IACA,aAAA;IACA,iBAAA;IACA,gBAAA;IACA,sBAAA;IACA,kDAAA;EA3BN;AACF;AA8BA;EACI;IACI,iBAAA;EA5BN;EA+BE;IACI,4BAAA;IACA,6BAAA;IACA,2BAAA;IACA,eAAA;EA7BN;EAkCE;IACI,yBAAA;IACA,sBAAA;IACA,4BAAA;IACA,6BAAA;IACA,yCAAA;EAhCN;EAmCE;IACI,yBAAA;IACA,sBAAA;IAIA,6BAAA;IAEA,6BAAA;IACA,yCAAA;EArCN;EAwCE;IACI,YAAA;EAtCN;EAwCE;IACI,YAAA;EAtCN;EAwCE;IACI,QAAA;IACA,SAAA;EAtCN;EAyCE;IACI,QAAA;EAvCN;EA0CE;IACI,QAAA;EAxCN;EA2CE;IACI,QAAA;EAzCN;EA4CE;IACI,2BAAA;EA1CN;EA4CE;IACI,6BAAA;IACA,2BAAA;EA1CN;AACF;AA6CA;EACI,YAAA;AA3CJ;;AA8CA;EACI,kBAAA;EACA,iBAAA;EACA,oBAAA;AA3CJ;;AA8CA;EACI,kBAAA;EACA,iBAAA;AA3CJ;;AA8CA;EACI,aAAA;EACA,qBAAA;AA3CJ;;AA8CA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AA3CJ","sourcesContent":[".rootContainer {\n    display: flex;\n    //flex-flow: row  nowrap;\n}\n\n.rootContainer>* {\n    //padding: 10px;\n    //background-color: white;\n    //color: white;\n    //margin: 10px;\n    //text-align: center;\n    //line-height: 75px;\n    background-color: black;\n    /* Black*/\n    font-size: 12px;\n    //font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif\n}\n\n.aside-2 {\n    //flex:1 1 20%;\n    background-color: black !important;\n    /* Black*/\n}\n\n.wrapper {\n    //flex:1 1 80%;\n    width: 100%;\n    flex-flow: column wrap;\n    align-items: stretch;\n    //font-weight: bold;\n    text-align: center;\n    background-color: black;\n    /* Black*/\n    border-radius: 25px 0px 0px 0px;\n}\n\n.wrapper>* {\n    flex: 1 1 100%;\n    padding: 10px;\n    background-color: white;\n    //color: black;\n    margin: 10px;\n    text-align: center;\n    //line-height: 75px;\n    font-size: 12px;\n}\n\n.header {\n    display: flex;\n    // background-color:  rgb(1, 6, 63); ;\n}\n\n.header>* {\n    flex: 1 1 70%;\n    background-color: white;\n    color: white;\n    text-align: right;\n    //line-height: 75px;\n    font-size: 12px;\n}\n\n.footer {\n    //padding-top:'100px';\n    text-align: center;\n    //margin-left:-170px;\n    background: white;\n}\n\n.nav {}\n\n.main {\n    //display:block;\n    text-align: left;\n    //height:600px;\n    //color:white;\n    background-color: white;\n}\n\n/* Style page content - use this if you want to push the page content to the right when you open the side navigation */\n#main {\n    transition: margin-left .5s;\n    padding: 20px;\n}\n\n/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */\n@media screen and (max-height: 450px) {\n    .sidenav {\n        padding-top: 15px;\n    }\n\n    .sidenav a {\n        font-size: 18px;\n    }\n}\n\n@media all and (min-width: 600px) {\n    .aside {\n        flex: 1 0 0;\n    }\n\n    // 🌟 FIXED FOR DESKTOP: Smoothly shifts the right-side wrapper container \n    // and locks its height/overflow properties so internal views handle the scrolling.\n    .sidenav.nav-expanded ~ .wrapper {\n        margin-left: 240px;\n        width: calc(100% - 240px);\n        height: 100vh;\n        max-height: 100vh;\n        overflow: hidden;\n        box-sizing: border-box;\n        transition: margin-left 0.3s ease, width 0.3s ease;\n    }\n\n    .sidenav.nav-collapsed ~ .wrapper {\n        margin-left: 70px;\n        width: calc(100% - 70px);\n        height: 100vh;\n        max-height: 100vh;\n        overflow: hidden;\n        box-sizing: border-box;\n        transition: margin-left 0.3s ease, width 0.3s ease;\n    }\n}\n\n@media all and (max-width: 599px) {\n    .rootContainer {\n        flex-flow: column;\n    }\n\n    body {\n        padding-left: 1em !important;\n        padding-right: 0em !important;\n        padding-top: 0em !important;\n        margin-top: 0px;\n    }\n    \n    // FIXED FOR MOBILE OPEN/CLOSED STATES: \n    // Dynamically alters the top spacing push based on whether the menu is actively expanded.\n    .sidenav.nav-collapsed ~ .wrapper {\n        margin-left: 0 !important;\n        width: 100% !important;\n        padding-top: 56px !important; // Fits just the closed top bar header height\n        border-radius: 0px !important;\n        transition: padding-top 0.25s ease-in-out;\n    }\n\n    .sidenav.nav-expanded ~ .wrapper {\n        margin-left: 0 !important;\n        width: 100% !important;\n        \n        // Push the entire layout downward dynamically by shifting page flow \n        // to clear the height block of the open horizontal mobile tiles area.\n        padding-top: 480px !important; \n        \n        border-radius: 0px !important;\n        transition: padding-top 0.25s ease-in-out;\n    }\n    \n    .wrapper{\n        padding: 0px;\n    }\n    .wrapper > *{\n        padding: 0px;\n    }\n    header {\n        order: 1;\n        flex: 3 0px;\n    }\n\n    aside-2 {\n        order: 2;\n    }\n\n    main {\n        order: 3;\n    }\n\n    footer {\n        order: 5;\n    }\n\n    .sidenav{\n        padding-top:0px!important;\n    }\n    .openSpan{\n        position:relative!important;\n        margin-top:-2px!important;\n    }\n}\n\nbody {\n    padding: 2em;\n}\n\nlabel {\n    margin-right: 10px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\ninput {\n    margin-right: 10px;\n    padding-top: 10px;\n}\n\n.labelText {\n    display: flex;\n    flex-flow: row nowrap;\n}\n\n.labelText>* {\n    flex: 1 1 100%;\n    text-align: left;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
